// @flow

export const LeagueLateLabel = {
	DRAFT: "This league was incomplete prior to the scheduled draft",
	CLASSIC: "This league was incomplete prior to its starting round",
};

export default LeagueLateLabel;